import React, { useEffect } from "react";
import { connect } from "react-redux";

import FormViewer from "modules/5_view_helpers/web/FormBuilder/FormViewer";
import { Button, ButtonGroup, Col, Row } from "reactstrap";
import { getUserManagements } from "modules/user_managements/actions";

function mapStateToProps(state) {
  return {
    projects: state.projects,
    employees: state.employees,
    custom_forms: state.custom_forms,
    custom_form_records: state.custom_form_records,
    react_dropzone_status: state.react_dropzone_status,
    users: state.users,
  };
}

const CustomFormRecordForm = (props) => {
  const { handleSubmit, formLabel, cancelFunction, custom_form, outlookMode, parents, parentSelectLabel, edit, submitForm, users } = props;

  const stillUploading = props.react_dropzone_status > 0;

  useEffect(() => {
    props.getUserManagements(true);
  }, []);


  return (
    <form>
      <FormViewer
        custom_form={custom_form}
        formLabel={formLabel}
        handleSubmit={handleSubmit}
        outlookMode={outlookMode} // Outlook Mode
        parents={parents} // Passing parents to form viewer for the outlook mode only.
        parentSelectLabel={parentSelectLabel}
        edit={edit}
        disabled={stillUploading}
        disabledMessage="File/s still uploading. Please wait."
        users={users}
        {...props}
      />

      <hr />
      <Row>
        <Col className="text-right ">
          <ButtonGroup>
            {custom_form?.workflow_style && (
              <Button
                onClick={() => {
                  submitForm(props.values);
                }}
                className="mr-2"
                disabled={stillUploading}
              >
                Save as Draft
              </Button>
            )}
            <Button onClick={cancelFunction} color="danger">
              Cancel
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
    </form>
  );
};

export default connect(mapStateToProps, { getUserManagements })(CustomFormRecordForm);
